import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import ChainedBackend from 'i18next-chained-backend'
import HttpBackend from 'i18next-http-backend'
import LocalStorageBackend from 'i18next-localstorage-backend'
import { Suspense } from 'react'
import Const from 'Utils/Consts'
import en from 'locales/en.json'
import fa from 'locales/fa.json'
import resourcesToBackend from 'i18next-resources-to-backend'

interface IProps {
  resourcePath: string
  children?: any
}

const InitialTranslation: React.FunctionComponent<IProps> = (props: IProps) => {
  i18n
    .use(initReactI18next)
    .use(ChainedBackend)
    .init({
      fallbackLng: 'fa',
      defaultNS: 'translation',
      ns: ['translation'],

      backend: {
        backends: [
          LocalStorageBackend,
          HttpBackend,
          resourcesToBackend({
            en: { translation: en },
            fa: { translation: fa },
          }),
        ],
        backendOptions: [
          {
            expirationTime: Const.env.REACT_APP_TRANSLATOR_CACHE_EXPIRE_TIME_IN_SECONDS, //24 * 60 * 60 * 1000 // 1 days
          },
          {
            loadPath: props.resourcePath,
          },
        ],
      },

      react: {
        useSuspense: true,
      },
    })

  return <Suspense fallback={<div>Loading... </div>}>{props.children}</Suspense>
}

export default InitialTranslation
